import { useFormContext } from "react-hook-form";
import { ReversedTransactionSelect } from "@/components/fields/reversed-transaction-select";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import type { PointTransaction } from "@/models/point-transaction";

interface FormReversedTransactionSelectProps {
  name: string;
  loyaltyAccountId: number;
  label?: string;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  onSelect?: (transaction: PointTransaction | null) => void;
}

export function FormReversedTransactionSelect({
  name,
  loyaltyAccountId,
  label,
  placeholder,
  required,
  disabled,
  onSelect,
}: FormReversedTransactionSelectProps) {
  const form = useFormContext();

  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem>
          {label && <FormLabel required={required}>{label}</FormLabel>}
          <FormControl>
            <ReversedTransactionSelect
              loyaltyAccountId={loyaltyAccountId}
              value={field.value}
              onChange={(transactionId, transaction) => {
                field.onChange(transactionId);
                onSelect?.(transaction);
              }}
              disabled={disabled}
              placeholder={placeholder}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
